<template>
  <div class="badge"> {{ text }} </div>
</template>
<script setup lang="ts">

const props = defineProps<{
  text: string
}>()

</script>
<style lang="scss">
.badge {
  color: $grey-60;
  font-family: $font-bold;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.5px;
  border: $grey-60 1px solid;
  border-radius: 2px;
  padding: 3px 3px 3px 4px;
  width: fit-content;
  height: fit-content;
}
</style>